import { useState, useEffect } from "react";
import SpeechRecognition, { useSpeechRecognition } from "react-speech-recognition";
import { isSupportedSpeechBrowser } from "../utilities";

export default function useSttWrapper(targetCharacters = 250) {
    const { transcript, resetTranscript } = useSpeechRecognition();
    const [progress, setProgress] = useState(0);
    const [message, setMessage] = useState("We expect you to speak for 1 minute or almost 250 words.");
    const supported = isSupportedSpeechBrowser();

    useEffect(() => {
        const count = transcript ? transcript.trim().length : 0;
        const p = Math.min((count / targetCharacters) * 100, 100);
        setProgress(p);

        if (p === 100) {
            setMessage("We have everything we need. Feel free to add more if you'd like.");
        } else if (p >= 90) {
            setMessage("Almost there... tell us a bit more...");
        } else if (p >= 75) {
            setMessage("Looking good! Just a little more...");
        } else if (p >= 50) {
            setMessage("You're halfway there! Share a bit more...");
        } else if (p > 0) {
            setMessage("Great start! Keep going...");
        } else if (p <= 0) {
            setMessage("We expect you to speak for 1 minute or almost 250 words.");
        } else {
            setMessage("");
        }
    }, [transcript, targetCharacters]);

    const start = () => {
        if (!supported) return;
        resetTranscript();
        SpeechRecognition.startListening({ continuous: true });
    };

    const stop = () => {
        if (!supported) return;
        SpeechRecognition.stopListening();
        setMessage((prev) => {
            if (progress > 0 && progress < 100) {
                return "We expect you to speak for 1 minute or almost 250 words.";
            }
            if (progress === 0) {
                return "We expect you to speak for 1 minute or almost 250 words.";
            }
            return prev;
        });
    };

    const reset = () => {
        if (supported) SpeechRecognition.abortListening();
        resetTranscript();
        setProgress(0);
        setMessage("We expect you to speak for 1 minute or almost 250 words.");
    };

    return {
        mode: "stt",
        supported,
        transcript,
        progress,
        message,
        start,
        stop,
        reset,
        loading: false,
    };
}


